import { redirectCartPage } from '../../../utils/redirect';
import { getAppProps } from '../../../utils';
import { createAddOnRecord } from '../../../addOnsUtil';
import { getHookCheckoutItems } from '../utils';

let oldState = [];
const TIMER = 1 * 1500;

function isChanged(oldState, newState) {
  if (JSON.stringify(oldState) !== JSON.stringify(newState)) {
    return true;
  }

  return false;
}

async function checkCartChangeInAddon(addOnsDb, oldState, newState) {
  let refreshPage = false;

  for (const itemOld of oldState) {
    // Check state diff
    const id = itemOld.id;
    const founded = newState.find(v => v.id === id);

    if (!founded) {
      const productId = itemOld.product_id;
      const defaultVariant = itemOld.product_has_only_default_variant;

      let iterId = null;

      if (defaultVariant) {
        iterId = `${productId}`;
      } else {
        iterId = `${productId}|${id}`;
      }

      let itemsPerCollection = null;

      for (const key in addOnsDb) {
        if (key.includes(iterId)) {
          itemsPerCollection = addOnsDb[key];
          break;
        }
      }

      // If we have products attached to upsell main product
      if (itemsPerCollection) {
        for (const key in itemsPerCollection) {
          const parsed = createAddOnRecord(itemsPerCollection, key);
          const { ids, specified } = parsed;

          // Should remove from cart?
          if (specified) {
            await jUpsell.ajax({
              url: '/cart/change.js',
              dataType: 'json',
              data: {
                quantity: 0,
                id: ids[0]
              },
              type: 'POST',
              xhrFields: {
                withCredentials: true
              }
            });

            refreshPage = true;
          }
        }
      }
    }
  }

  return refreshPage;
}

async function checkAndRemove(oldState, newState) {
  const { addOnsDb, popups } = getAppProps();

  // Check popups changes
  const popupsChanged = await checkCartChangeInAddon(
    popups,
    oldState,
    newState
  );

  // Check addon changes
  const addonsChanged = await checkCartChangeInAddon(
    addOnsDb,
    oldState,
    newState
  );

  if (popupsChanged || addonsChanged) {
    redirectCartPage();
  }
}

function getCartItems() {
  return new Promise(resolve => {
    jUpsell
      .getJSON('/cart.js', function(cart) {
        resolve(cart.items);
      })
      .fail(() => {
        resolve([]);
      });
  });
}

export async function initCartChangesHook() {
  oldState = getHookCheckoutItems();

  // Check state before all
  await checkAndRemove([], oldState);

  if (Proxy) {
    window.fetch = new Proxy(window.fetch, {
      apply(fetch, that, args) {
        const result = fetch.apply(that, args);

        result.then(async (response) => {
          if (args[0].includes('/cart/change')) {
            const newState = await getCartItems();

            if (isChanged(oldState, newState)) {
              await checkAndRemove(oldState, newState);

              oldState = newState;
            }
          }
        });

        return result;
      }
    });
  } else {
    window.setInterval(async () => {
      const newState = await getCartItems();

      if (isChanged(oldState, newState)) {
        await checkAndRemove(oldState, newState);

        oldState = newState;
      }
    }, TIMER);
  }
}
